import { useState } from "react";

export function useMultipStepForm(steps) {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    function next() {
        window.scrollTo(0, 100);
        setCurrentStepIndex(i => {
            if (i >= steps.length - 1) return i
            return i + 1;
        })
    }

    function back() {
        window.scrollTo(0, 100);
        setCurrentStepIndex(i => {
            if (i <= 0) return i
            return i - 1;
        })
    }

    return {
        currentStepIndex,
        step: steps[currentStepIndex],
        steps,
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === steps.length - 1,
        next,
        back,
        description: steps[currentStepIndex].props.description,
        header: steps[currentStepIndex].props.header
    }
}